



















import Vue from 'vue';
export default Vue.extend({
	name: 'StepNav', 
	props: {
		step: Number, 
		items: Array, 
		disableForward: Boolean
	}, 
	methods: {
		stepClass(i: number): string {
			const isDisabled = this.disableForward && i > this.step;
			const disabledClass = isDisabled ? 'evo-disabled' : '';
			const activeClass = this.step === i ? 'evo-nav-active' : '';
			const completeClass = this.step > i ? 'evo-nav-completed' : '';
			return `${activeClass} ${completeClass} ${disabledClass}`;
		}, 
		handleItemClick(i: number): void {
			const isDisabled = this.disableForward && i > this.step;
			if (i != this.step && !isDisabled){
				(this as any).$emit('click', i);
			}
		}
	}
});
